import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import App from './App';
import { setCurrentScene } from '../../actions';
import { ApiErrorModal } from '../apiErrorModal';

class AppContainer extends Component {
    componentWillMount() {
        // If the URL has a scene in its path then lets push that over to the current scene.
        // Only works on page loads given it happens when the component mounts.
        const { scene, path, setCurrentScene } = this.props;

        if (!scene) {
            setCurrentScene(path.substring(1));
        }
    }

    componentWillReceiveProps(nextProps) {
        const { path: newPath, scene: newScene, push, setCurrentScene } = nextProps;
        const { path: oldPath, scene: oldScene } = this.props;

        if (newPath !== oldPath) {
            setCurrentScene(newPath.substring(1));
        } else if (newScene !== oldScene && newScene !== oldPath.substring(1)) {
            push(newScene);
        }
    }

    render() {
        return [
            <App key='app'/>,
            <ApiErrorModal key='errormodal' />
        ];
    }
}

AppContainer.propTypes = {
    path:            PropTypes.string.isRequired,
    scene:           PropTypes.string.isRequired,
    setCurrentScene: PropTypes.func.isRequired,
    push:            PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    path: state.router.location.pathname,
    scene: state.scene.current,
    showErrorModal: state.ui.error.show,
    errorMessage: state.ui.error.text
});

const mapDispatchToProps = ({
    setCurrentScene,
    push
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppContainer);



// WEBPACK FOOTER //
// ./src/components/app/AppContainer.js